import type { searchForm } from 'shared';

import {
  googleAnalyticsEventsLib,
  amplitudeEventsLib,
  appsFlyerEventsLib,
  jsBridgeEventsLib,
  extractAnalyticsDataLib,
  bloomreachEventsLib,
} from '..';
import type {
  MultiTripToggleDirection,
  MultiTripValidationErrorCode,
  MainPageVariant,
} from '../amplitude-events';

export type SubmitSearchFormParams = ReturnType<
  typeof searchForm.model.useSearchForm
>;

export const mainPageOpen = (
  // eslint-disable-next-line default-param-last
  source: string | null = null,
  variant?: MainPageVariant,
) => {
  googleAnalyticsEventsLib.mainPageOpen();
  amplitudeEventsLib.mainPageOpen(source, variant);
  jsBridgeEventsLib.homepageViewed();
};

export const submitSearchForm = (
  params: SubmitSearchFormParams,
  source: string,
  variant?: MainPageVariant,
) => {
  const mappedSearchFormParams = {
    ...params,
    passengers: {
      adt: params.isYouth.value ? 0 : params.passengers.value.adt,
      chd: params.isYouth.value ? 0 : params.passengers.value.chd,
      inf: params.isYouth.value ? 0 : params.passengers.value.inf,
      yth: params.isYouth.value ? params.passengers.value.yth : 0,
    },
  };

  const properties = extractAnalyticsDataLib.searchForm(mappedSearchFormParams);

  googleAnalyticsEventsLib.submitSearchForm(properties);
  amplitudeEventsLib.submitSearchForm(properties, source, variant);
  appsFlyerEventsLib.submitSearchForm(properties);
  bloomreachEventsLib.searchButtonClick(properties, source);
  jsBridgeEventsLib.searchButtonClicked(properties, params?.routes?.value);
};

export const blogClick = () => {
  amplitudeEventsLib.blogClick();
};

export const switchCitiesClick = () => {
  amplitudeEventsLib.switchCitiesClick();
};

export const myTicketsPageOpen = (sourceScreen: string | null = null) => {
  jsBridgeEventsLib.myTicketsPageOpen({ sourceScreen });
  amplitudeEventsLib.ticketPageClick(sourceScreen);
};

export const mainScroll = (params: {
  scroll_depth: number;
  scroll_blocks: string[];
}) => {
  amplitudeEventsLib.mainScroll(params);
};

export const mainPageLayoutAssigned = (widgets: readonly string[]) => {
  amplitudeEventsLib.mainPageLayoutAssigned(widgets);
};

export const multiTripToggleClick = (params: {
  direction: MultiTripToggleDirection;
  source: string;
}) => {
  amplitudeEventsLib.multiTripToggleClick(params);
};

export const multiTripAutoExit = (params: { source: string }) => {
  amplitudeEventsLib.multiTripAutoExit(params);
};

export const multiTripInfoOpen = (params: {
  source: string;
  legs_count: number;
}) => {
  amplitudeEventsLib.multiTripInfoOpen(params);
};

export const multiTripSubmitValidationFailed = (params: {
  error_codes: MultiTripValidationErrorCode[];
  legs_count: number;
  failed_leg_indexes: number[];
  source: string;
}) => {
  amplitudeEventsLib.multiTripSubmitValidationFailed(params);
};
